import { render, staticRenderFns } from "./CancellationWorkflow.vue?vue&type=template&id=a3498ace&scoped=true"
import script from "./CancellationWorkflow.vue?vue&type=script&lang=ts"
export * from "./CancellationWorkflow.vue?vue&type=script&lang=ts"
import style0 from "./CancellationWorkflow.vue?vue&type=style&index=0&id=a3498ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3498ace",
  null
  
)

export default component.exports